import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useOrgEntitlements } from '../hooks/useOrgEntitlements';
import { DashboardFocusShell } from '../components/dashboard-focus/DashboardFocusShell';
import ClinicianDashboard from './ClinicianDashboard';
import ProviderOSDashboard from './ProviderOSDashboard';
import AgencyDashboard from './AgencyDashboard';

/**
 * ProviderHome — the single Provider destination (/provider-os) for the
 * merged clinician + provider role. One URL, the right workspace:
 *   • clinician accounts   → their full clinician workspace
 *   • org accounts w/ flag → Provider OS (offers/paperwork/first visits)
 *   • org accounts w/o     → agency workspace (never a locked screen)
 * Backend role values are unchanged — this is presentation-level only.
 */
export default function ProviderHome() {
  const { user } = useAuth();
  const { loading, hasFlag } = useOrgEntitlements();

  if (user?.role === 'clinician') {
    return (
      <DashboardFocusShell role="clinician">
        <ClinicianDashboard />
      </DashboardFocusShell>
    );
  }
  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-slate-500">
        <div className="animate-pulse" data-testid="provider-home-loading">
          Loading provider workspace…
        </div>
      </div>
    );
  }
  if (!hasFlag('provider_os')) {
    return (
      <DashboardFocusShell role="agency">
        <AgencyDashboard />
      </DashboardFocusShell>
    );
  }
  return <ProviderOSDashboard />;
}
